import React, { useEffect, useRef } from 'react'

// bootstrap
import { Modal } from 'react-bootstrap'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// form fields
import AppFormikInput from 'utlis/helpers/forms/AppFormikInput'

export default function AddTrackingNumberModal(props) {
    // props
    const {
        modalVisibility,
        closeModal,

        orderId,

        selectedTrackingNumber,
        setTrackingNumber,

        setSelectedTrackingNumber
    } = props

    // initial form values
    const initialFormValues = {
        withoutTracking: selectedTrackingNumber ? "0" : "1",
        trackingNumber: selectedTrackingNumber || "",
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        withoutTracking: Yup.string().required('This field is required'),
        trackingNumber: Yup.string().when("withoutTracking", {
            is: "0",
            then: Yup.string().required("This field is required")
        }),
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            if (values.withoutTracking === "1") {
                setSelectedTrackingNumber("")
            }

            setTrackingNumber(values.trackingNumber) // setting tracking number

            closeModal() // closing the modal
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
    })

    // setting field values if available
    useEffect(() => {
        if (selectedTrackingNumber) {
            formik.setFieldValue("withoutTracking", selectedTrackingNumber ? "0" : "1",)
            formik.setFieldValue("trackingNumber", selectedTrackingNumber)
        }
    }, [selectedTrackingNumber])

    return (
        <Modal
            show={modalVisibility}
            onHide={closeModal}
            centered
            size={"lg"}
            className="st-info-modal">
            <Modal.Body className="st-modal">
                {/* close icon */}
                <div className="app-modal-content modal_add-tracking-number position-relative pt-0" style={{ minHeight: 'auto' }}>
                    <button
                        className="close-icon position-absolute st-round-btn st-btn-sm st-btn-white d-flex align-items-center justify-content-center"
                        onClick={closeModal}
                        style={{ top: 0, right: 0 }}>
                        <FeatherIcon
                            icon="x"
                            size="20"
                            className="icon position-relative" />
                    </button>


                    {/* head */}
                    <div className="app-modal-title-wrapper">
                        <p className="app-modal-title">Mark order #{orderId ?? ""} as shipped</p>
                    </div>

                    <div className="form">
                        <form onSubmit={formik.handleSubmit}
                            noValidate
                            autoComplete="off">
                            {/* radio */}
                            <label className="st-custom-radio d-inline-flex mb-3">
                                <input
                                    type="radio"
                                    className="d-none"
                                    value="1"
                                    name="withoutTracking"
                                    checked={formik.values.withoutTracking === "1"}
                                    onChange={formik.handleChange}

                                />
                                <span className="round mt-0 position-relative" style={{ top: 3 }}>
                                    <span className="inner"></span>
                                </span>
                                {/* text */}
                                <span className="text media-body st-text-dark">
                                    <span className="head d-block st-fw-600 st-fs-17 mb-1 st-text-color">Shipped without tracking number</span>
                                    <span className="head d-block st-text-color2 st-fs-15">Customer will receive status update via email notification.</span>
                                </span>
                            </label>

                            {/* radio */}
                            <label className="st-custom-radio d-inline-flex mb-2">
                                <input
                                    type="radio"
                                    className="d-none"
                                    value="0"
                                    name="withoutTracking"
                                    checked={formik.values.withoutTracking === "0"}
                                    onChange={formik.handleChange}

                                />
                                <span className="round mt-0 position-relative" style={{ top: 3 }}>
                                    <span className="inner"></span>
                                </span>
                                {/* text */}
                                <span className="text media-body st-text-dark">
                                    <span className="head d-block st-fw-600 st-fs-17 mb-1 st-text-color">Shipped with tracking number (enter tracking number below)</span>
                                    <span className="head d-block st-text-color2 st-fs-15">Customer will receive status update and tracking number via email notification.</span>
                                </span>
                            </label>

                            {
                                formik.values.withoutTracking === "0" ? (
                                    <React.Fragment>
                                        <div className="tracking-input-container" style={{ paddingLeft: 32 }}>
                                            {/* form field */}
                                            <AppFormikInput
                                                formik={formik} // formik object
                                                stFormClass={"form-sm mb-0"} // class name for main wrapper
                                                labelName={"Tracking Number"} // label name
                                                isRequired={true} // is this field is required or not to show the red star sign
                                                placeholder={"Tracking Number"} // placeholder for the input
                                                formikFieldName={"trackingNumber"} // important: formik value name for the input
                                            />
                                        </div>
                                    </React.Fragment>
                                ) : null
                            }

                            <div className="btns mt-3 mt-lg-4" style={{ width: 200 }}>
                                <button type="submit" className="st-btn st-btn-primary text-capitalize w-100">Mark as shipped</button>
                            </div>
                        </form>
                    </div>

                </div>
            </Modal.Body>
        </Modal>
    )
}
